import { render, staticRenderFns } from "./RemoveAppretice.vue?vue&type=template&id=7993984c&"
import script from "./RemoveAppretice.vue?vue&type=script&lang=js&"
export * from "./RemoveAppretice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports